import React from 'react';
import {
  ClockIcon,
  SunIcon,
  MoonIcon,
  NoSymbolIcon,
} from '@heroicons/react/24/outline';
import { TWButton, TWModal } from '../../../ui';

const options = [
  { value: 1, label: '1 Hour', icon: ClockIcon },
  { value: 3, label: '3 Hours', icon: ClockIcon },
  { value: 12, label: '12 Hours', icon: SunIcon },
  { value: 'tomorrow', label: 'Until Tomorrow', icon: MoonIcon },
  { value: 'forever', label: 'Forever', icon: NoSymbolIcon },
];

export default function OptionVisibleModal({
  show,
  onCloseVisible,
  onSelectVisible,
}) {
  return (
    <TWModal
      open={show}
      onClose={onCloseVisible}
      title="Hide this option for"
      size="sm"
      showCloseButton
      footer={
        <TWButton
          variant="default"
          label="Cancel"
          onClick={onCloseVisible}
          className="w-full"
        />
      }
    >
      <div className="grid grid-cols-2 gap-2">
        {options.map((opt) => {
          const Icon = opt.icon;
          return (
            <button
              key={opt.value}
              type="button"
              onClick={() => onSelectVisible(opt.value)}
              className="flex items-center gap-2.5 rounded-md border border-slate-200 bg-white px-3.5 py-3 text-left transition hover:border-blue-400 hover:bg-blue-50 active:scale-[0.97] dark:border-slate-600 dark:bg-slate-700 dark:hover:border-sky-400 dark:hover:bg-slate-600"
            >
              <Icon className="h-5 w-5 flex-shrink-0 text-slate-400 dark:text-slate-300" />
              <span className="text-sm font-semibold text-slate-800 dark:text-slate-100">
                {opt.label}
              </span>
            </button>
          );
        })}
      </div>
    </TWModal>
  );
}
